export default __webpack_public_path__ + "static/media/boberVid.ae3da9ea.mp4";